import { isNarrativeOnlyToggleEnabled } from "../features/narrative-only-toggle/featureFlag";
import { useFeatureFlags } from "./useFeatureFlags";

export function useNarrativeOnlyToggleEnabled(): boolean {
  const featureFlags = useFeatureFlags();
  return isNarrativeOnlyToggleEnabled(featureFlags);
}
